function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIdcaptureWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 581.36 232.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.77,
    y: 75.14,
    width: 5.15,
    height: 46.19,
    rx: 1.25,
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,116.78c10.82,0,18.41-7.72,18.41-18.61s-7.59-18.54-18.41-18.54H258v37.15ZM253,76.39a1.23,1.23,0,0,1,1.19-1.25h14.78a23.1,23.1,0,1,1,0,46.19H254.14a1.23,1.23,0,0,1-1.19-1.25Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52,74.48c6.66,0,11.48,2.31,16,6.14a1.29,1.29,0,0,1,.07,1.85l-1.79,1.78c-.53.66-1,.59-1.72-.07a19.28,19.28,0,0,0-12.6-5C318,79.23,310,88,310,98.24s8,18.94,18.41,18.94c5.74,0,9.11-2,12.6-5a1.13,1.13,0,0,1,1.72.06l1.52,1.53a1.26,1.26,0,0,1-.07,1.78,23.39,23.39,0,0,1-15.7,6.4,23.76,23.76,0,1,1,0-47.52",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.35,105.63c-3.24-7.19-6.4-14.45-9.64-21.64h-.52l-9.64,21.64Zm-31.35,14,20.06-44.41a1.19,1.19,0,0,1,1.13-.73h.65a1.2,1.2,0,0,1,1.13.73l19.92,44.41a1.16,1.16,0,0,1-1.12,1.72h-2.63a1.22,1.22,0,0,1-1.13-.73l-4.88-10.89H356.7l-4.82,10.89a1.22,1.22,0,0,1-1.12.73h-2.64a1.17,1.17,0,0,1-1.12-1.72",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,99.69a9.83,9.83,0,0,0,10-10.1c0-5.87-4.62-9.44-10-9.44H400.46V99.69Zm-15.51-23.3a1.25,1.25,0,0,1,1.25-1.25h14.59a14.72,14.72,0,1,1,.07,29.43H400.46v15.51a1.3,1.3,0,0,1-1.26,1.25h-2.51a1.25,1.25,0,0,1-1.25-1.25Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.37,79.56H429.89a1.24,1.24,0,0,1-1.25-1.25V76.39a1.24,1.24,0,0,1,1.25-1.25h28a1.25,1.25,0,0,1,1.26,1.25v1.92a1.25,1.25,0,0,1-1.26,1.25H446.39v40.52a1.3,1.3,0,0,1-1.26,1.25h-2.5a1.3,1.3,0,0,1-1.26-1.25Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.4,76.39a1.29,1.29,0,0,1,1.25-1.25h2.51a1.26,1.26,0,0,1,1.26,1.25v27.79c0,7.52,4.68,13.13,12.4,13.13s12.54-5.47,12.54-13V76.39a1.25,1.25,0,0,1,1.25-1.25h2.52a1.3,1.3,0,0,1,1.25,1.25v28.18c0,10-7.13,17.43-17.56,17.43s-17.42-7.39-17.42-17.43Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.28,98.9a9.47,9.47,0,1,0,0-18.94h-12.8V98.9Zm-18-22.51a1.24,1.24,0,0,1,1.25-1.25h17.1A14.18,14.18,0,0,1,544,89.2c0,6.07-4,11.15-9.76,13.46l9,16.77a1.24,1.24,0,0,1-1.13,1.9H539a1.44,1.44,0,0,1-1.46-1L529,103.26h-12.6v16.82a1.3,1.3,0,0,1-1.25,1.25h-2.58a1.24,1.24,0,0,1-1.25-1.25Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.85,76.39a1.24,1.24,0,0,1,1.25-1.25h26a1.25,1.25,0,0,1,1.26,1.25v1.92a1.26,1.26,0,0,1-1.26,1.25H557.93V95.67h18.94a1.29,1.29,0,0,1,1.25,1.25v1.92a1.25,1.25,0,0,1-1.25,1.25H557.93v16.82H580.1a1.26,1.26,0,0,1,1.26,1.26v1.91a1.25,1.25,0,0,1-1.26,1.25h-26a1.24,1.24,0,0,1-1.25-1.25Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.46,147.9h-5.09v8h5.24c3.51,0,5.24-1.26,5.24-4s-2.16-4-5.39-4m.24-9h-5.33v7.19h5.3c2.4,0,4-1.24,4-3.55s-1.53-3.64-4-3.64m.15,18.9h-7.67V137H246c2.86,0,5.89,1.63,5.89,5.39a4.77,4.77,0,0,1-3.21,4.44A5,5,0,0,1,253,152c0,4.11-3.33,5.83-7.18,5.83",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.64,139.88l-3.79,9.65h7.62Zm7.09,17.91-2.52-6.38h-9.1l-2.49,6.38h-2.4l8.56-21.08h1.88l8.51,21.08Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.93 138.99 285.93 157.79 283.73 157.79 283.73 138.99 276.03 138.99 276.03 137.02 293.6 137.02 293.6 138.99 285.93 138.99",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.47,
    y: 137.02,
    width: 2.19,
    height: 20.77,
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.06 157.94 325.78 157.94 321.07 141.09 316.29 157.94 314.07 157.94 308.47 137.02 310.87 137.02 315.37 154.58 320.17 137.02 322.12 137.02 326.98 154.52 331.42 137.02 333.73 137.02 328.06 157.94",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.62,138.53c-5,0-7.61,4.22-7.61,8.87s2.58,8.88,7.61,8.88,7.61-4.22,7.61-8.88-2.59-8.87-7.61-8.87m0,19.66c-6.54,0-9.86-5.18-9.86-10.82s3.32-10.75,9.86-10.75,9.86,5.11,9.86,10.75-3.33,10.82-9.86,10.82",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.49,138.89h-5.18v8.3h5c2.62,0,4.56-1.33,4.56-4.22a4,4,0,0,0-4.34-4.08m5.23,18.9-6-8.72h-4.46v8.72h-2.19V137h7.46c3.54,0,6.44,2.16,6.44,5.92a5.57,5.57,0,0,1-4.87,5.82l6.32,9Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.49,157.79l-9.93-10.64L399.64,137h2.87L392.4,147.13l10.13,10.66ZM386.58,137h2.19v20.77h-2.19Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.78,
    y: 149.71,
    width: 6.47,
    height: 1.82,
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.54 154.77 449.57 137.02 451.97 137.02 443.4 157.94 441.53 157.94 433.02 137.02 435.45 137.02 442.54 154.77",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.84,
    y: 137.02,
    width: 2.19,
    height: 20.77,
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.4,138.53c-3.08,0-4.46,1.38-4.46,3.33,0,5.48,11.52,3.17,11.52,10.5,0,3.8-3.14,5.83-7.3,5.83a9.2,9.2,0,0,1-7.49-3.33l1.63-1.51a7.08,7.08,0,0,0,5.92,2.93c3.2,0,5-1.42,5-3.52,0-6.06-11.53-3.32-11.53-10.56,0-2.87,1.94-5.58,6.69-5.58a8.34,8.34,0,0,1,6.93,3.17l-1.53,1.45a6.35,6.35,0,0,0-5.34-2.71",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.18,
    y: 137.02,
    width: 2.19,
    height: 20.77,
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.88,138.53c-5,0-7.61,4.22-7.61,8.87s2.59,8.88,7.61,8.88,7.61-4.22,7.61-8.88-2.58-8.87-7.61-8.87m0,19.66c-6.53,0-9.86-5.18-9.86-10.82s3.33-10.75,9.86-10.75,9.86,5.11,9.86,10.75-3.32,10.82-9.86,10.82",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.66,147.9h-5.08v8h5.24c3.51,0,5.24-1.26,5.24-4s-2.16-4-5.4-4m.25-9h-5.33v7.19h5.3c2.4,0,4-1.24,4-3.55s-1.53-3.64-4-3.64m.15,18.9h-7.67V137h7.83c2.86,0,5.88,1.63,5.88,5.39a4.76,4.76,0,0,1-3.2,4.44,5,5,0,0,1,4.34,5.11c0,4.11-3.33,5.83-7.18,5.83",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.85,139.88l-3.79,9.65h7.62Zm7.09,17.91-2.53-6.38h-9.09l-2.49,6.38h-2.41L553,136.71h1.88l8.51,21.08Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "573.13 138.99 573.13 157.79 570.94 157.79 570.94 138.99 563.24 138.99 563.24 137.02 580.8 137.02 580.8 138.99 573.13 138.99",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.11,193l47.71,27.55,78.53-46.88-48.87-27Zm47.8,39.66-68.4-39.49,97.76-58.57,70,38.72Z",
    style: {
      fill: "#acc5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.83,73.69l79.05,45.64V63.72l-79-45.64Zm89.49,63.72L99.39,79.72V0l99.93,57.69Z",
    style: {
      fill: "#acc5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44,65.24v91.33l48.15-27.79V36.39ZM0,174.66V59.32L69.05,18,69,134.8Z",
    style: {
      fill: "#acc5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.56,168.94l79.05,45.63V159l-79-45.64Zm89.49,63.72L.11,175V95.25l99.94,57.69Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.91,59,69.49,86,147,39.56,99.48,12.11ZM69.68,98.07,0,59.32,99.39,0l68.24,39.4Z",
    style: {
      fill: "#015f67"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.72,103.87v92.21l48.15-28.69V76.06ZM130.27,214.46V97.84l69-39.86V173.32Z",
    style: {
      fill: "#015f67"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIdcaptureWhite);
export default __webpack_public_path__ + "static/media/logo_idcapture_white.7fd030e4565c6443cd11c5af85a89b9c.svg";
export { ForwardRef as ReactComponent };